function formatNum (num) {
    let newNum = parseInt(num, 10) || 0;

    if (newNum >= 10000 && newNum < 10000000) {
        newNum = `${(newNum / 10000).toFixed(2)}万`;
    } else if (newNum >= 10000000 && newNum < 100000000) {
        newNum = `${(newNum / 10000).toFixed(1)}万`;
    } else if (newNum >= 100000000) {
        newNum = `${parseInt((newNum / 10000), 10)}万`;
    }

    return newNum;
}

function formatNum1 (data, units = 'w') {
    if (!data) {
        return 0;
    }

    if (units === 'w' && +data >= 10000) {
        return `${(data / 10000).toFixed(1)}万`;
    }

    if (units === 'y' && +data > 100000000) {
        return `${(data / 100000000).toFixed(1)}亿`;
    }

    return +data || 0;
}

function getParams (name) {
  // 构造一个含有目标参数的正则表达式对象
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  // 匹配目标参数
    const returnData = window.location.search.substr(1).match(reg);
  // 返回参数值

    if (returnData != null) {
        return unescape(returnData[2]);
    }

    return null;
}

// 转换格式
function formatTime (num) {
    return num < 10 ? (`0${num}`) : num;
}

// 时间戳（单位s）获取倒计时的时、分、秒
function getCountDownHMS (time) {
    if (!time) {
        return {};
    }

    const days = formatTime(parseInt(time / (60 * 60 * 24), 10));
    const hours = formatTime(parseInt(time / (60 * 60), 10) % 24);
    const mins = formatTime(parseInt(time / 60, 10) % 60);

    return {
        days,
        hours,
        mins
    };
}

// 获取当前时间戳的时、分、秒，单位s
function getHMS (time) {
    const myDate = new Date(time * 1000);
    const year = myDate.getFullYear();
    const month = formatTime(myDate.getMonth() + 1);
    const day = formatTime(myDate.getDate());
    const hour = formatTime(myDate.getHours());
    const minute = formatTime(myDate.getMinutes());
    const second = formatTime(myDate.getSeconds());

    return {
        year,
        month,
        day,
        hour,
        minute,
        second
    };
}

export default {
    formatNum,
    formatNum1,
    getParams,
    getCountDownHMS,
    getHMS
};
